import { Stack } from "@mui/material"
import { colors } from "../../services/config/colors"
import BreadcrumbDesktop from "../global/desktop/BreadcrumbDesktop"
import Title from "../global/common/Title"
import AppearFromSide from "../animations/AppearFromSide"
import { useContext } from "react"
import {
  desktopMaxWidth,
  footerHeight,
  navBarHeight,
} from "../../services/config/constants"
import ActionDetailsBackgroundDesktop from "../../assets/svgComponents/ActionDetailsBackgroundDesktop"
import { MainContext } from "../../controllers/main"
import PaddingContainerDesktop from "../global/desktop/PaddingContainerDesktop"
import { useTranslation } from "react-i18next"
import Text from "../global/common/Text"
import LeaderboardListItem from "../performance/common/LeaderboardListItem"
import SavingCard from "../actions/common/SavingCard"
import FadeFromTop from "../animations/FadeFromTop"
import rocket from "../../assets/icons/rocket.svg"
import communityIcon from "../../assets/icons/community.svg"
import LeaderboardTop3 from "../performance/common/LeaderboardTop3"
import { CommunityContext } from "../../controllers/community"

const CommunityDesktop = () => {
  const { t } = useTranslation()
  const { windowHeight, user } = useContext(MainContext)
  const { community } = useContext(CommunityContext)

  return (
    <Stack
      style={{
        width: "100%",
        minHeight:
          windowHeight > 1200 ? `calc(100% - ${footerHeight}px)` : 1200,
        position: "relative",
      }}
    >
      {/* navbar background */}
      <div
        style={{
          width: "100%",
          height: navBarHeight,
          backgroundColor: colors.background,
        }}
      />
      {/* breadcrumb */}
      <BreadcrumbDesktop
        items={[
          {
            label: t("community"),
          },
        ]}
        selectedItem={0}
        style={{ marginTop: 22, zIndex: 1 }}
      />
      {/* main container */}
      <PaddingContainerDesktop>
        <Stack
          style={{
            width: "100%",
            maxWidth: desktopMaxWidth,
            position: "relative",
            zIndex: 1,
          }}
        >
          {/* header */}
          <Stack
            style={{
              position: "relative",
              marginTop: 22,
            }}
          >
            <AppearFromSide fade>
              <Title
                fontSize={36}
                lineHeight="46px"
                component="h1"
                color={colors.primary}
                style={{ fontStyle: "italic" }}
              >
                {t("partner_community").toUpperCase()}
              </Title>
            </AppearFromSide>
            <AppearFromSide fade delay={0.05}>
              <Text
                fontSize={28}
                lineHeight="46px"
                fontWeight={400}
                style={{ marginTop: 8 }}
              >
                {t("partner_community_description")}
              </Text>
            </AppearFromSide>
          </Stack>
          {/* content */}
          <FadeFromTop
            style={{
              width: "100%",
              marginTop: 42,
              marginBottom: 58,
              position: "relative",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Stack direction="row" style={{ width: "100%", gap: 120 }}>
              {/* overview */}
              <Stack
                gap={2}
                style={{
                  width: "100%",
                }}
              >
                <Title fontSize={26} lineHeight="46px">
                  {t("overview")}
                </Title>
                <Stack
                  style={{
                    width: "100%",
                    padding: 46,
                    backgroundColor: colors.backgroundWhite,
                    boxShadow: "0px 0px 24px 0px rgba(147, 160, 167, 0.16)",
                    borderRadius: 10,
                  }}
                >
                  <Stack gap={4} direction="row">
                    <Stack
                      alignItems="center"
                      style={{
                        width: "100%",
                        height: 150,
                        borderRadius: 16,
                        border: "1px solid " + colors.primary,
                        backgroundColor: colors.backgroundWhite,
                        paddingTop: 18,
                      }}
                    >
                      <img src={communityIcon} style={{ height: 30 }} alt="" />
                      <Title
                        fontSize={26}
                        lineHeight="28px"
                        color={colors.primary}
                        style={{ marginTop: 16 }}
                      >
                        {community?.userCount}
                      </Title>
                      <Text
                        fontSize={16}
                        lineHeight="18px"
                        fontWeight={400}
                        textAlign="center"
                        style={{ marginTop: 5, width: 100 }}
                      >
                        {t("total_participants")}
                      </Text>
                    </Stack>
                    <Stack
                      alignItems="center"
                      style={{
                        width: "100%",
                        height: 150,
                        borderRadius: 16,
                        border: "1px solid " + colors.primary,
                        backgroundColor: colors.backgroundWhite,
                        paddingTop: 18,
                      }}
                    >
                      <img src={rocket} style={{ height: 30 }} alt="" />
                      <Title
                        fontSize={26}
                        lineHeight="28px"
                        color={colors.primary}
                        style={{ marginTop: 16 }}
                      >
                        {community?.totalMissions}
                      </Title>
                      <Text
                        fontSize={16}
                        lineHeight="18px"
                        fontWeight={400}
                        textAlign="center"
                        style={{ marginTop: 5, width: "100%" }}
                      >
                        {t("total_completed_missions")}
                      </Text>
                    </Stack>
                  </Stack>
                  <Title
                    fontSize={24}
                    lineHeight="46px"
                    style={{ marginTop: 36 }}
                  >
                    {t("description")}
                  </Title>
                  <div
                    style={{
                      fontSize: 20,
                      lineHeight: "32px",
                      fontWeight: 300,
                      color: colors.text,
                    }}
                    dangerouslySetInnerHTML={{
                      __html: t("community_description"),
                    }}
                  />
                  {community &&
                  community.savings &&
                  (community.savings.co2Saving ||
                    community.savings.waterSaving ||
                    community.savings.energySaving) ? (
                    <>
                      <Title
                        fontSize={24}
                        style={{ marginTop: 26 }}
                        component="h4"
                      >
                        {t("total_community_savings")}*
                      </Title>
                      <Stack
                        direction="row"
                        className="hide-scrollbars"
                        gap={2}
                        style={{
                          width: "100%",
                          maxWidth: "100%",
                          overflowX: "scroll",
                          marginTop: 16,
                        }}
                      >
                        {community.savings.co2Saving ? (
                          <SavingCard
                            metric="co2"
                            amount={community.savings.co2Saving}
                          />
                        ) : null}
                        {community.savings.waterSaving ? (
                          <SavingCard
                            metric="water"
                            amount={community.savings.waterSaving}
                          />
                        ) : null}
                        {community.savings.energySaving ? (
                          <SavingCard
                            metric="energy"
                            amount={community.savings.energySaving}
                          />
                        ) : null}
                      </Stack>
                      <Text
                        fontSize={14}
                        fontWeight={400}
                        style={{ marginTop: 16 }}
                      >
                        *L’impatto ambientale totale è calcolato sull’intera
                        durata della community.
                      </Text>
                    </>
                  ) : null}
                </Stack>
              </Stack>
              {/* leaderboard */}
              <Stack
                gap={2}
                style={{
                  width: "100%",
                }}
              >
                <Title fontSize={26} lineHeight="46px">
                  {t("leaderboard")}*
                </Title>
                <LeaderboardTop3
                  leaderboard={community!.bestUsers}
                  style={{ marginTop: 20 }}
                />
                {community!.bestUsers.length > 3 ? (
                  <Stack
                    style={{
                      width: "100%",
                      height: 383,
                      maxHeight: 383,
                      borderRadius: 16,
                      backgroundColor: colors.backgroundWhite,
                      boxShadow:
                        "0px 0px 35.68513px 0px rgba(17, 67, 97, 0.08)",
                      marginTop: 26,
                      overflowY: "auto",
                    }}
                  >
                    {community!.bestUsers.slice(3).map((item, index) => (
                      <Stack key={index}>
                        <div
                          style={{
                            width: "100%",
                            height: 2,
                            backgroundColor:
                              !index && item.sub !== user!.sub
                                ? colors.backgroundWhite
                                : colors.backgroundLight,
                          }}
                        />
                        <LeaderboardListItem
                          place={item.position}
                          name={`${item.first_name} ${item.last_name}`}
                          points={item.points}
                          isUser={item.sub === user!.sub}
                          profileImage={item.profileImage}
                          height={74.59}
                        />
                      </Stack>
                    ))}
                  </Stack>
                ) : (
                  <Text
                    fontSize={18}
                    fontWeight={400}
                    style={{ marginTop: 30 }}
                  >
                    {t("leaderboard_empty_state")}.
                  </Text>
                )}
                <Stack direction="row" gap={2} style={{ marginTop: 6 }}>
                  <Text fontSize={14} fontWeight={400}>
                    *La classifica mostra gli utenti più virtuosi dalla nascita
                    della community.
                  </Text>
                </Stack>
              </Stack>
            </Stack>
          </FadeFromTop>
        </Stack>
      </PaddingContainerDesktop>
      {/* background */}
      <div
        style={{
          width: "100%",
          maxWidth: 1920,
          height: "100%",
          maxHeight: "100%",
          overflow: "hidden",
          position: "absolute",
          top: 0,
          right: 0,
        }}
      >
        <ActionDetailsBackgroundDesktop
          color={colors.background}
          style={{ position: "absolute", top: 600 }}
        />
      </div>
    </Stack>
  )
}

export default CommunityDesktop
